<div class="fixed transform z-2" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-0 pb-0">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>Stroke Alert Cases</a></div>
    </div>
  </div>
    <p-table #dt [value]="strokeAlertCases" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines" responsiveLayout="scroll" [rowHover]="true"
    sortMode="multiple" [customSort]="true" (sortFunction)="customSort($event)" [resizableColumns]="true" columnResizeMode="expand">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:40rem" pSortableColumn="date" pResizableColumn>Date<p-sortIcon field="date"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="EMS" pResizableColumn>EMS Arrival #<p-sortIcon field="EMS"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="EMSPercent" pResizableColumn>Proportion EMS<p-sortIcon field="EMSPercent"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="Triage" pResizableColumn>PV/Walk In Arrival #<p-sortIcon field="Triage"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="TriagePercent" pResizableColumn>Proportion PV/ Walk In<p-sortIcon field="TriagePercent"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="Inpatient" pResizableColumn>Inpatient #<p-sortIcon field="Inpatient"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="InpatientPercent" pResizableColumn>Proportion Inpatient<p-sortIcon field="InpatientPercent"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="EDOnset" pResizableColumn>ED Onset #<p-sortIcon field="EDOnset"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="EDOnsetPercent" pResizableColumn>Proportion ED Onset<p-sortIcon field="EDOnsetPercent"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="AudioConsult" pResizableColumn>Audio Consult #<p-sortIcon field="AudioConsult"></p-sortIcon></th>
          <th style="width:40rem" pSortableColumn="AudioConsultPercent" pResizableColumn>Proportion Audio Consult<p-sortIcon field="AudioConsultPercent"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-strokeAlertCases>
        <tr>
          <td>{{strokeAlertCases.date}}</td>
          <td>{{strokeAlertCases.EMS}}</td>
          <td>{{strokeAlertCases.EMSPercent}}</td>
          <td>{{strokeAlertCases.Triage}}</td>
          <td>{{strokeAlertCases.TriagePercent}}</td>
          <td>{{strokeAlertCases.Inpatient}}</td>
          <td>{{strokeAlertCases.InpatientPercent}}</td>
          <td>{{strokeAlertCases.EDOnset}}</td>
          <td>{{strokeAlertCases.EDOnsetPercent}}</td>
          <td>{{strokeAlertCases.AudioConsult}}</td>
          <td>{{strokeAlertCases.AudioConsultPercent}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <h5 *ngIf="totalRecords==0" class="text-center create-roles">
            <b> No records found</b>
          </h5>
        </tr>
      </ng-template>
    </p-table>
    <div class="md:col-12">
      <span class="tableRefreshTime">
        Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
      </span>
    </div>
</div>

<!-- Pi-Chart Dialog -->
<p-dialog [(visible)]="piChartBool" [breakpoints]="{'960px': '75vw'}" [draggable]="false" [style]="{width: '50%'}"
  [modal]="true" styleClass="p-fluid">

  <ng-template pTemplate="content">
    <div class="grid" *ngIf="!checkPiChartBool">
      <p-button  type="button" icon="pi pi-file-pdf" (onClick)="exportPdf()" label="Save as PDF"
        class="p-button-primary mr-1"></p-button>
    </div>
    <div class="p-fluid formgrid">
      <div class="chart-popup" id="htmlData">
        <span>
          <span class="piechart-header">
              <p class="pie-text">Stroke Alert Chart, {{dateConvertLive}} - {{strokeAlertCases[strokeAlertCases.length - 1].date}}</p>
          </span>
          <span class="piechart-header" *ngIf="!checkPiChartBool">
            <p class="text-center pie-text">Total Cases - {{TotaAllCases}}</p>
          </span>
          <kendo-chart title=""  *ngIf="!checkPiChartBool">
            <kendo-chart-legend position="bottom"></kendo-chart-legend>
            <kendo-chart-series>
              <kendo-chart-series-item type="pie" [data]="pieData" field="value" categoryField="category"
              colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent }">
              </kendo-chart-series-item>
            </kendo-chart-series>
          </kendo-chart>
          <h1 *ngIf="checkPiChartBool" class="text-center">No Record Found</h1>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template  pTemplate="footer"> 
      <button id="pie-chart"  pButton type="button" (click)="hideChartDiaglog()" class=" btn-UnCancelCase">
        <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
  </ng-template>
</p-dialog>
